module.exports = __webpack_public_path__ + "static/media/add_blood_req.5c24bccc.png";